module.exports = __webpack_public_path__ + "static/media/SCR-A-new2.8d7c39b3.mp3";